import { createAction, props } from "@ngrx/store";
import { UserCred } from "../model/auth.model";

const AUTH_LOGIN = '[Auth] Login'
const AUTH_SUCCESS = '[Auth] Login Success'
const AUTH_FAILURE = '[Auth] Login Failure'
const AUTH_LOGOUT = '[Auth] Login Failure'

export const login = createAction(AUTH_LOGIN, props<{userCred:UserCred}>());
export const loginSuccess = createAction(AUTH_SUCCESS);
export const loginFailure = createAction(AUTH_FAILURE, props<{ error: any }>());
export const logout = createAction(AUTH_LOGOUT);


const AUTH_CKECK_STATUS = '[Auth] Check Auth Status'
const AUTH_CKECK_STATUS_SUCCESS = '[Auth] Check Auth Status Success'
const AUTH_CKECK_STATUS_FAILURE = '[Auth] Check Auth Status Failure'

export const checkAuthStatus = createAction(AUTH_CKECK_STATUS);
export const checkAuthStatusSuccess = createAction(AUTH_CKECK_STATUS_SUCCESS, props<{ isAuthenticated: boolean }>());
export const checkAuthStatusFailure = createAction(AUTH_CKECK_STATUS_FAILURE, props<{ error: any }>());

